import update, { Spec, extend } from 'immutability-helper';

type UnknownSpec = Spec<Record<string, unknown>>;
type UnknownArraySpec = Spec<Array<unknown>>;

extend('$auto', (value: UnknownSpec, object: Record<string, unknown> | undefined) => {
    return object ? update(object, value) : update({}, value);
});

extend('$autoArray', (value: UnknownArraySpec, object: Array<unknown> | undefined) => {
    return object ? update(object, value) : update([], value);
});

export default update;
